import React from 'react'
import withTypeProps from './withTypeProps'

const Heading = ({ children, defaultStyles }) => {
  return <h1 style={{ ...defaultStyles, fontSize: '5rem' }}>{children}</h1>
}

export default withTypeProps(Heading)
